import axios from 'axios'
import router from '@/router'
import { getToken } from '@/local/user'
import { APP_PATH_LOGIN } from '@/configs/app'
import { isInAppWebview } from '@/utils/bridge'

function isResponseOk(response) {
    return response.status >= 200 && response.status < 300 && response.data && response.data.status >= 200 && response.data.status < 300
}

function convertResponseToError(response, detail) {
    let status = response.status
    let code = -1
    let message = '网络请求错误，请重试'
    if (response.data && response.data.status) {
        code = response.data.status
        if (code === 401 || response.status === 401) {
            message = '请重新登录'
        } else if (response.data.msg) {
            message = response.data.msg
        }
    }
    return {
        status,
        code,
        message,
        detail
    }
}

function handleError(error) {
    if (error.code === 401 || error.status === 401) {
        if (isInAppWebview()) {
            window.open(APP_PATH_LOGIN)
        } else {
            router.push('/login')
        }
    }
}

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'Cache-Control': 'no-cache',
        'Channel': 'h5'
    }
})

instance.interceptors.request.use(config => {
    const token = getToken()
    if (token) {
        config.headers['Token'] = token
    }
    return config
}, error => {
    error = {
        status: 0,
        code: -1,
        message: '错误的请求配置',
        detail: error
    }
    if (process.env.VUE_APP_LOG_ENABLED === 'true') {
        console.error({
            tag: 'http-request',
            error
        })
    }
    handleError(error)
    return Promise.reject(error)
})

instance.interceptors.response.use(response => {
    if (isResponseOk(response)) {
        if (process.env.VUE_APP_LOG_ENABLED === 'true') {
            console.info(response)
        }
        return response.data.data
    } else {
        const error = convertResponseToError(response, response)
        if (process.env.VUE_APP_LOG_ENABLED === 'true') {
            console.error({
                tag: 'http-response',
                error
            })
        }
        handleError(error)
        throw error
    }
}, error => {
    error = convertResponseToError(error.response, error)
    if (process.env.VUE_APP_LOG_ENABLED === 'true') {
        console.error({
            tag: 'http-response',
            error
        })
    }
    handleError(error)
    return Promise.reject(error)
})

export default instance
